export default "__VITE_ASSET__def9366e__"